import { render } from "./ChartDistribution.vue?vue&type=template&id=de5a9358&scoped=true"
import script from "./ChartDistribution.vue?vue&type=script&lang=js"
export * from "./ChartDistribution.vue?vue&type=script&lang=js"

import "./ChartDistribution.vue?vue&type=style&index=0&id=de5a9358&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5a9358"]])

export default __exports__